import { ValuesQuestion } from './values'
import { StrengthsQuestion } from './strengths'
import { MbtiQuestion } from './mbti'
import { BigFiveQuestion } from './bigFive'
import { EnneagramQuestion } from './enneagram'

export type AssessmentOption =
  | 'none'
  | 'bigFive'
  | 'values'
  | 'strengths'
  | 'enneagram'
  | 'mbti'

export type AssessmentData = {
  currentQuestion:
    | ValuesQuestion
    | BigFiveQuestion
    | StrengthsQuestion
    | MbtiQuestion
    | EnneagramQuestion
  currentAnswer?: number
  currentQuestionIndex: number
  more: boolean
  progress: number
  answerQuestion: (
    question:
      | ValuesQuestion
      | BigFiveQuestion
      | StrengthsQuestion
      | MbtiQuestion
      | EnneagramQuestion,
    answer: number,
  ) => void
  goToQuestion: (index: number) => void
  submit: () => Promise<void>
  submitting: boolean
}

type assessmentContext = {
  title: string
  instructions: string
  leftText?: string
  rightText?: string
}

interface AssessmentInfo {
  values: assessmentContext
  strengths: assessmentContext
  mbti: assessmentContext
  bigFive: assessmentContext
  enneagram: assessmentContext
}

export const assessmentInfo: AssessmentInfo = {
  values: {
    title: 'Values Assessment',
    instructions: `Rate each statement on this page from 1-5 based on how often the
    belief guides your behavior`,
    leftText: 'Never',
    rightText: 'Always',
  },
  strengths: {
    title: 'Strengths Assessment',
    instructions: `Rate each statement on this page from 1-5 based on how true you think
      it is about you.`,
    leftText: 'Disagree',
    rightText: 'Agree',
  },
  mbti: {
    title: '16-Personality Assessment',
    instructions: `Select a circle closer to the statement that is most like you.`,
  },
  bigFive: {
    title: 'Big Five Assessment',
    instructions: `Rate each statement on this page from 1-5 based on how you see yourself
    in relation to your peers`,
    leftText: 'Very Inaccurate',
    rightText: 'Very Accurate',
  },
  enneagram: {
    title: 'Enneagram Assessment',
    instructions: `Rate each statement on this page from 1-5 based on how true you think it
      is about you.`,
    leftText: 'Disagree',
    rightText: 'Agree',
  },
}
